import { OnInit, OnDestroy, NgZone } from "@angular/core";
import { EntitiesInformationService } from "app/private/sidebar-information/entity-information.service";

export class BaseComponent implements OnInit, OnDestroy {
  constructor(public informationService: EntitiesInformationService) {}

  ngOnInit(): void {
    document.getElementById("container-principal").classList.remove("container");
    document.getElementById("breadcrumb-principal").style.display = "none";
    document.getElementById("entityInformation").style.display = "block";
  }

  ngOnDestroy(): void {
    document.getElementById("breadcrumb-principal").style.display = "block";
    document.getElementById("entityInformation").style.display = "none";
    document.getElementById("container-principal").classList.add("container");
    this.informationService.clean();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/base/base.component.ts